import { Redirect, Route } from 'react-router-dom';

import { IRoute } from 'types/common';

interface Props extends IRoute {
  isAuthenticated: boolean;
  to?: string;
}

export function RoutePublic({ component: Component, isAuthenticated, to = '/administracija', ...rest }: Props) {
  const { path } = rest;
  return (
    <Route
      {...rest}
      render={(props) =>
        path !== '/' &&
        path !== '/objavi' &&
        path !== '/smrtovnica/:ime/:id' &&
        path !== '/smrtovnica/:id' &&
        path !== '/placanje/:uuid' &&
        path !== '/invoice/:id' &&
        isAuthenticated ? (
          <Redirect to={{ pathname: to }} />
        ) : (
          Component && <Component {...props} />
        )
      }
    />
  );
}
